import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CartContentComponent } from '../../shared/cart-content/cart-content.component';
import { RequestAppointmentComponent } from '../../appointment/request-appointment/request-appointment.component';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { LocationService } from '@services/location.service';
import { Location } from 'src/app/models/location.model';
import { getSidebarContentType } from 'src/app/lib/content-type.util';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { TranslatePipe } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { GiftCardContentComponent } from '../../shared/gift-card-content/gift-card-content.component';

@Component({
  selector: 'app-slider-right',
  templateUrl: './slider-right.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CartContentComponent,
    GiftCardContentComponent,
    RequestAppointmentComponent,
    NzCardComponent,
    NzTypographyComponent,
    TranslatePipe,
  ],
})
export class SliderRightComponent implements OnInit {
  @Input() isModal = false;
  @Output() closeRequested = new EventEmitter<void>();
  contentType: 'cart' | 'gift-card' | 'request-appointment' = 'cart';
  private location: Location;

  constructor(
    private locationService: LocationService,
    private router: Router,
    private readonly destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.location = this.locationService.getLocation();
    this.updateContentType();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.updateContentType());

    this.locationService.locationChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((location) => {
      this.location = location;
      this.updateContentType();
    });
  }

  private updateContentType(): void {
    this.contentType = getSidebarContentType(this.router.routerState.snapshot.root, this.location);
  }

  onCloseRequested(): void {
    this.closeRequested.emit();
  }
}
